import algoliasearch from 'algoliasearch'

export const algoliaClient = (appId: string, searchKey: string) => {
  const searchClient = algoliasearch(appId, searchKey)

  const index = searchClient.initIndex('article_post')

  return index
}
